import React from 'react';
import Autographs from './Autographs';
import Shoutouts from './Shoutouts';
import Endorsements from './Endorsements';
import Appearances from './Appearances';
// import TalentProvided from './TalentProvided';
import CreativeMedia from './CreativeMedia';
import css from './SignatureServices.module.css';

const SignatureServices = props => {
  const { viewport } = props;
  return (
    <div className={css.servicesSec}>
      <div className={css.serviceBlock}>
        <Autographs viewport={viewport} {...props} />
        {/* <TalentProvided {...props} /> */}
        <Shoutouts viewport={viewport} {...props} />
        <Endorsements viewport={viewport} {...props} />
        <CreativeMedia viewport={viewport} {...props} />
        <Appearances viewport={viewport} {...props} />
      </div>
    </div>
  );
};

export default SignatureServices;
